import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { datum } from "@/lib/format";
import { getDeregistrationHistory, type DeregistrationHistory } from "@/lib/permitDeregistrations";

export function PermitDeregistrationHistory({ workerId }: { workerId: string }) {
  const { can } = useAuth();
  const read = can("dozvola", "read");
  const [items, setItems] = useState<DeregistrationHistory[]>([]);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!read) return;
    const controller = new AbortController();
    void getDeregistrationHistory(workerId, controller.signal).then(value => { if (!controller.signal.aborted) setItems(value); }).catch(cause => { if (!controller.signal.aborted) setError(errorMessage(cause, "Povijest odjava nije dostupna.")); });
    return () => controller.abort();
  }, [workerId, read]);
  if (!read) return null;
  if (error) return <p role="alert">{error}</p>;
  if (!items.length) return null;
  return <section className="my-4 rounded border p-4"><h2 className="font-semibold">Predmeti odjave</h2><ul>{items.map(item => <li key={item.process_id}><Link className="inline-flex min-h-11 items-center underline" to={`/dozvole/odjave/${item.process_id}`}>{item.case_number} · prestanak {datum(item.termination_on)} · {item.status === "completed" ? "Zatvoren" : "U tijeku"}</Link></li>)}</ul></section>;
}
